const commonCN = {
    COMMON_01: 'Paid',
    COMMON_02: 'Problem in payment',
    COMMON_03: 'Parameter error!',
    COMMON_04: 'Recharge failed! Please recharge!',
    COMMON_05: 'Recharge Success!',
    COMMON_06: 'Alipay',
    COMMON_07: 'Please enter an amount larger than 0',
    COMMON_08: 'Identify Code',
    COMMON_09: 'Re-Send',
    COMMON_10: 'Please input amount',
    CANCELLIMIT: 'Cancel the limit of search results page',

    LOOK_AT_THE_CONTACT: 'Check Contact',
    MIAL_FORMAT_ERROR: 'Mial format error!',
    SAVE_SUCCEED: 'Edit succeed',
    EDIT_FALL_RETRY: 'Edit failure，retry!',
    OLD_PASSWORD_ERROR: 'Old password error !',
    NO_LIMIT: 'no limit',
    COMPANY_SEARCH: 'Company search',
    PERSON_SEARCH: 'Contact search',
    PER_DETAIL_COMPANY: 'Company Detail',

    C001: 'Add successfully',
    C002: 'Add failed'


}
export default commonCN


// WEBPACK FOOTER //
// ./src/lan/en/en_common.js